export default __webpack_public_path__ + "static/media/JavaScriptCoffeeTextLogo.bb0dbb83.png";